import { post, put } from '@/api/request';

function createProfile(data) {
  return post('/profiles', data);
}

function updateProfile({ id, data }) {
  return put(`/profiles/${id}`, data);
}

export default {
  createProfile,
  updateProfile,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/api.js